import useSWRImmutable from 'swr/immutable';

import { GameCategory } from '@/api/games';
import { fetcherSS } from '@/modules/api';

export const useCollections = () => {
  const {
    data = [],
    error,
    isLoading,
  } = useSWRImmutable<GameCategory[]>(`/games/collections`, fetcherSS);

  return {
    data,
    isLoading,
    isError: error,
    collections: data,
  };
};
